import {useEffect, useState} from 'react';
import {alertByError} from 'utils/alerts';
import {getLandingStats} from 'api/common';
import {get} from 'lodash';

function useGetStats() {
  const [isLoading, setIsLoading] = useState(false);
  const [stats, setStats] = useState({});

  async function getStats() {
    setIsLoading(true);
    try {
      const {data} = await getLandingStats();

      const {active_ab, searchable_cb, certs, ces, locations} = data || {};

      const stats = {
        companies: get(ces, 'counts'),
        certs: get(certs, 'counts'),
        locations: get(locations, 'counts'),
        standards: 300,
        cbs: get(searchable_cb, 'counts'),
        abs: get(active_ab, 'counts'),
      };

      setStats(stats);
    } catch (e) {
      alertByError(e);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    getStats();
  }, [false]);

  return {stats, isLoading};
}

export default useGetStats;
